import React from "react";
import useWeek from "../../hooks/queryResults/useWeek";
import LeagueAllWaiversRequests from "./LeagueAllWaiversRequests";
import LeagueSeasonWaiversPriorityList from "./LeagueSeasonWaiversPriorityList";
import LeagueWaiversCountdownClock from "./LeagueWaiversCountdownClock";

export default function LeagueSeasonAdmin() {
  const { currentWeek } = useWeek();

  return (
    <div>
      <h1>Admin - Week {currentWeek}</h1>
      <LeagueWaiversCountdownClock />
      <LeagueAllWaiversRequests />
      <LeagueSeasonWaiversPriorityList />
    </div>
  );
}
